/**
 *
 * CompletedTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinTripIcon from 'assets/v2/PinTripIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.budGreenDark};
    background: ${COLORS.budGreenLight};
    border-color: ${COLORS.budGreen};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.budGreen};
    }
  }
`;

function CompletedTag(props) {
  return <StyledTag label="Completed" icon={<PinTripIcon />} {...props} />;
}

export default memo(CompletedTag);
